export const defaultResOrRec = {
	asunto: '',
	texto: '',
	responsible: [],
	addresseeR: [],
	accompaniment: [],
	addresseeA: [],
	tipoTema: '',
	previousSessions: '',
	periodicidad: '',
	filingDate: null,
	sessionDate: null,
	deadline: null,
	notificationDate: null,
	estatus: 'PE',
	ordenDia: null,
	notificar: false,
};

export const filterForm = (organs = [], sessionsPrevious = [], disabledInputs) => [
	{
		label: '*Órgano Colegiado',
		name: 'organ',
		placeholder: 'Órgano Colegiado',
		type: 'dropdown',
		options: [...organs],
		column: 5,
		disabled: disabledInputs,
	},
	{
		label: '*Mes de Sesión',
		name: 'month',
		type: 'dropdown',
		options: [
			{ value: '01', text: 'Enero' },
			{ value: '02', text: 'Febrero' },
			{ value: '03', text: 'Marzo' },
			{ value: '04', text: 'Abril' },
			{ value: '05', text: 'Mayo' },
			{ value: '06', text: 'Junio' },
			{ value: '07', text: 'Julio' },
			{ value: '08', text: 'Agosto' },
			{ value: '09', text: 'Septiembre' },
			{ value: '10', text: 'Octubre' },
			{ value: '11', text: 'Noviembre' },
			{ value: '12', text: 'Diciembre' },
		],
		column: 2,
		disabled: disabledInputs,
	},
	{
		label: '*Año de Sesión',
		name: 'year',
		type: 'text',
		isNumber: true,
		column: 2,
		disabled: disabledInputs,
	},
	{
		label: '*Sesión Anterior',
		name: 'sessions',
		type: 'dropdown',
		options: [...sessionsPrevious],
		column: 3,
		disabled: disabledInputs,
	},
];

export const highResForm = (
	institutions = [],
	recipientsResponsible = [],
	recipientsAccompaniment = [],
	points = [],
	disabledInputs,
	status
) => [
	{
		label: 'Tipo de Tema',
		name: 'tipoTema',
		type: 'dropdown',
		options: [
			{ value: 'RES', text: 'Resolucion' },
			{ value: 'REC', text: 'Recomendacion' },
		],
		column: 6,
		disabled: disabledInputs,
	},
	{
		label: 'Asunto',
		name: 'asunto',
		placeholder: 'Número de Resolución',
		type: 'text',
		column: 6,
		disabled: disabledInputs,
	},
	{
		label: 'Texto',
		name: 'texto',
		type: 'text',
		column: 12,
		disabled: disabledInputs,
		adjustable: true,
	},
	{
		label: 'Responsable',
		name: 'responsible',
		type: 'search-multiple',
		options: [...institutions],
		column: 12,
		disabled: disabledInputs,
	},
	{
		label: 'Destinatario',
		name: 'addresseeR',
		type: 'search-multiple',
		options: [...recipientsResponsible],
		column: 12,
		disabled: disabledInputs,
	},
	{
		label: 'Acompañamiento',
		name: 'accompaniment',
		type: 'search-multiple',
		options: [...institutions],
		column: 12,
		disabled: disabledInputs,
	},
	{
		label: 'Destinatario',
		name: 'addresseeA',
		type: 'search-multiple',
		options: [...recipientsAccompaniment],
		column: 12,
		disabled: disabledInputs,
	},
	{
		label: 'Periodicidad',
		name: 'periodicidad',
		type: 'dropdown',
		options: [
			{ value: 'U', text: 'Única Ocasión' },
			{ value: 'M', text: 'Mensual' },
			{ value: 'B', text: 'Bimestral' },
			{ value: 'T', text: 'Trimestral' },
			{ value: 'C', text: 'Cuatrimestal' },
			{ value: 'S', text: 'Semestral' },
			{ value: 'A', text: 'Anual' },
		],
		column: 2,
		disabled: disabledInputs,
	},
	{
		label: 'Fecha de Sesión',
		name: 'sessionDate',
		type: 'date',
		column: 2,
		disabled: true,
	},
	{
		label: 'Fecha de Presentación',
		name: 'filingDate',
		type: 'date',
		column: 2,
		disabled: disabledInputs,
	},
	{
		label: 'Fecha Limite de Entrega',
		name: 'deadline',
		type: 'date',
		column: 2,
		disabled: disabledInputs,
	},
	{
		label: 'Fecha de Notificacion',
		name: 'notificationDate',
		type: 'date',
		column: 2,
		disabled: disabledInputs,
	},
	{
		label: 'Estatus',
		name: 'estatus',
		type: 'dropdown',
		options: disabledInputs
			? [
					{ value: 'PE', text: 'Pendiente' },
					{ value: 'AS', text: 'Asignada' },
					{ value: 'EP', text: 'En proceso' },
					{ value: 'AT', text: 'Atendida' },
					{ value: 'A', text: 'Atendida' },
					{ value: 'P', text: 'Pendiente' },
					{ value: 'APO', text: 'En proceso para Responsable órgano' },
			  ]
			: [
					{ value: 'PE', text: 'Pendiente' },
					{ value: 'AS', text: 'Asignada' },
					{ value: 'EP', text: 'En proceso' },
					{ value: 'AT', text: 'Atendida' },
			  ],
		column: 2,
		disabled: disabledInputs,
	},
	{
		label: 'Punto Orden del Día',
		name: 'ordenDia',
		type: 'dropdown',
		options: [...points],
		column: status ? 10 : 12,
		disabled: disabledInputs,
	},
	status
		? {
				label: 'Resolucion de atención',
				name: 'resolucionAsociada',
				placeholder: 'Resolucion de atención',
				type: 'text',
				column: 2,
				disabled: disabledInputs,
		  }
		: {},
];

export const action_buttons = (onSave, clean, onreturn, disabled, loading = false) => [
	{ title: 'Regresar', color: 'info', onClick: onreturn, className: 'ml-4' },
	{
		title: 'Limpiar',
		color: 'light-primary',
		onClick: clean,
		className: disabled ? 'd-none' : 'mx-4',
		disabled: disabled,
		loading: false,
	},
	{
		title: 'Guardar',
		color: 'primary',
		onClick: onSave,
		disabled: disabled,
		className: disabled ? 'd-none' : 'mx-4',
		loading: loading,
	},
];
